import { Box, Typography } from "@mui/material"

import type { BulkLabel } from "@app/services/types"
import { LabelDataGrid } from "./LabelDataGrid"
import { LabelViewHeader } from "./LabelViewHeader"

type LabelViewProps = {
	bulkLabels: BulkLabel[]
}

export const LabelView: React.FC<LabelViewProps> = ({ bulkLabels }) => {
	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				border: "1px solid",
				borderColor: "divider",
				borderRadius: "12px",
				minWidth: 0,
				minHeight: 0,
				flexDirection: "column",
				flex: 1,
				overflow: "hidden",
			}}
		>
			{bulkLabels.length === 0 ? (
				<Box
					sx={{
						width: "100%",
						minWidth: 0,
						boxSizing: "border-box",
						display: "flex",
						flexDirection: "column",
						overflow: "hidden",
					}}
				>
					<LabelViewHeader bulkLabels={bulkLabels} />

					<Box sx={{ p: "10px", textAlign: "center" }}>
						<Typography variant="h6" fontWeight="bold">
							No IDs Generated Yet
						</Typography>
						<Typography variant="body2">
							Select bulk cat class and click "Generate ID" to create some!
						</Typography>
					</Box>
				</Box>
			) : (
				<LabelDataGrid bulkLabels={bulkLabels} />
			)}
		</Box>
	)
}
export default LabelView
